export interface SupportEmailTranslations {
  unknown: string;
  subject: string;
  greeting: string;
  intro: string;
  section1_title: string;
  user_email_label: string;
  name_label: string;
  feature_label: string;
  timestamp_label: string;
  section2_title: string;
  problem_question: string;
  problem_placeholder: string;
  steps_title: string;
  step_placeholder: string;
  section3_title: string;
  os_label: string;
  browser_label: string;
  screen_label: string;
  error_label: string;
  error_placeholder: string;
  screenshot_label: string;
  screenshot_placeholder: string;
  thanks: string;
  regards: string;
}

export function getBrowserInfo(unknownLabel: string): {
  os: string;
  browser: string;
} {
  const ua = navigator.userAgent;
  let os = unknownLabel;
  let browser = unknownLabel;

  if (ua.includes('Windows NT 10')) os = 'Windows 10/11';
  else if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('Mac OS X')) {
    const match = ua.match(/Mac OS X (\d+[._]\d+)/);
    os = match ? `macOS ${match[1].replace('_', '.')}` : 'macOS';
  } else if (ua.includes('Linux')) os = 'Linux';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('iOS') || ua.includes('iPhone') || ua.includes('iPad'))
    os = 'iOS';

  if (ua.includes('Edg/')) {
    const match = ua.match(/Edg\/(\d+\.\d+)/);
    browser = match ? `Edge ${match[1]}` : 'Edge';
  } else if (ua.includes('Chrome/')) {
    const match = ua.match(/Chrome\/(\d+\.\d+)/);
    browser = match ? `Chrome ${match[1]}` : 'Chrome';
  } else if (ua.includes('Safari/') && !ua.includes('Chrome')) {
    const match = ua.match(/Version\/(\d+\.\d+)/);
    browser = match ? `Safari ${match[1]}` : 'Safari';
  } else if (ua.includes('Firefox/')) {
    const match = ua.match(/Firefox\/(\d+\.\d+)/);
    browser = match ? `Firefox ${match[1]}` : 'Firefox';
  }

  return { os, browser };
}

export function buildSupportEmailUrl(
  userEmail: string,
  userName: string,
  currentPath: string,
  translations: SupportEmailTranslations,
  locale: string = 'de-DE',
): string {
  const { os, browser } = getBrowserInfo(translations.unknown);
  const now = new Date();
  const timestamp = now.toLocaleString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  });
  const screenRes = `${window.screen.width}x${window.screen.height}`;

  const t = translations;

  const body = `${t.greeting}

${t.intro}

${t.section1_title}
━━━━━━━━━━━━━━━━━━━━━━
${t.user_email_label} ${userEmail}
${t.name_label} ${userName}
${t.feature_label} ${currentPath}
${t.timestamp_label} ${timestamp}

${t.section2_title}
━━━━━━━━━━━━━━━━━━━━━━
${t.problem_question}
${t.problem_placeholder}

${t.steps_title}
1. ${t.step_placeholder.replace('{{number}}', '1')}
2. ${t.step_placeholder.replace('{{number}}', '2')}
3. ${t.step_placeholder.replace('{{number}}', '3')}

${t.section3_title}
━━━━━━━━━━━━━━━━━━━━━━
${t.os_label} ${os}
${t.browser_label} ${browser}
${t.screen_label} ${screenRes}
${t.error_label} ${t.error_placeholder}
${t.screenshot_label} ${t.screenshot_placeholder}

${t.thanks}

${t.regards}
${userName}`;

  return `mailto:admin@syncara.io?subject=${encodeURIComponent(t.subject)}&body=${encodeURIComponent(body)}`;
}
